import React, {useContext, useEffect, useRef, useState} from 'react';
import {LayoutContext} from "../../../../../../layout/context/LayoutContext";
import {Toast} from "primereact/toast";
import {usePagination} from "../../../../../../layout/hooks/usePagination";
import {useFetch} from "../../../../../../layout/hooks/useFetch";
import {webInfo} from "../../../../../../utils/webInfo";
import callToast, {
    formattedDateTime,
    handleChangeData, handleDelete,
    mergeWithSelected,
    postData,
    validateFormFields
} from "../../../../../../utils/helper";
import {Button} from "primereact/button";
import PageHeading from "../../../../../../Components/PageHeading";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Dialog} from "primereact/dialog";
import Label from "../../../../../../Components/Label";
import {Dropdown} from "primereact/dropdown";
import {ProgressSpinner} from "primereact/progressspinner";
import mapboxgl from "mapbox-gl";
import {Calendar} from "primereact/calendar";
import {ConfirmPopup, confirmPopup} from "primereact/confirmpopup";



const ParkingReservation = () => {
    const initialState = {
        vehicle_id: null,
        user_id: null,
        vehicle_parking_campus_id: null,
        vehicle_parking_floor_id: null,
        vehicle_parking_slot_id: null,
        reservation_start_date:"",
        reservation_end_date:"",
    };

    const {accessToken} = useContext(LayoutContext)
    const [refresh, setRefresh] = useState<boolean>(false);
    const [formData, setFormData] = useState<any>(initialState);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);


    const [recurringStatusIsSubmitting, setRecurringStatusIsSubmitting] = useState<boolean>(false);
    const [statusIsSubmitting, setStatusIsSubmitting] = useState<boolean>(false);

    const toastRef = useRef<Toast | null>(null)
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    const [modal, setModal] = useState<boolean>(false);
    const [updatedId, setUpdatedId] = useState<number | null>(null);

    const [vehicleNameFilter, setVehicleNameFilter] = useState<string>('');
    const [vehicleOptions, setVehicleOptions] = useState<{ id: number, name: string }[]>([]);

    const [userFilter, setUserFilter] = useState<string>('');
    const [userOptions, setUserOptions] = useState<{ id: number, name: string }[]>([]);

    const [parkingCampusNameFilter, setParkingCampusNameFilter] = useState<string>('');
    const [parkingCampusOptions, setParkingCampusOptions] = useState<{ id: number, name: string }[]>([]);

    const [parkingFloorNameFilter, setParkingFloorNameFilter] = useState<string>('');
    const [parkingFloorOptions, setParkingFloorOptions] = useState<{ id: number, floor_name: string, floor_level:number }[]>([]);

    const [parkingSlotNameFilter, setParkingSlotNameFilter] = useState<string>('');
    const [parkingSlotOptions, setParkingSlotOptions] = useState<{ id: number, slot_code: string }[]>([]);

    const deleteId = useRef<number>(0)
    const [mapModal, setMapModal] = useState<boolean>(false);
    const [locationData, setLocationData] = useState<{
        latitude: string | number,
        longitude: string | number,
        name: string,
        address: string
    }>({
        latitude: '90.4125', longitude: '23.8103', name: '', address: ''
    });

    const showMapContainerRef = useRef<HTMLDivElement>(null);
    const mapRef = useRef<mapboxgl.Map | null>(null);
    const markerRef = useRef<mapboxgl.Marker | null>(null);
    const [recurringStatusEditMode, setRecurringStatusEditMode] = useState<boolean>(false);
    const [statusEditMode, setStatusEditMode] = useState<boolean>(false);


    const initMap = () => {
        // Only use showMapContainerRef for view mode
        const targetContainer = showMapContainerRef.current;
        if (!targetContainer) return;

        mapboxgl.accessToken = webInfo?.mapBoxToken;

        const rawLat = parseFloat(String(locationData.latitude));
        const rawLng = parseFloat(String(locationData.longitude));
        const isValidLat = !isNaN(rawLat) && rawLat >= -90 && rawLat <= 90;
        const isValidLng = !isNaN(rawLng) && rawLng >= -180 && rawLng <= 180;

        const finalLng = isValidLng ? rawLng : 90.4125;
        const finalLat = isValidLat ? rawLat : 23.8103;

        mapRef.current = new mapboxgl.Map({
            container: targetContainer,
            style: 'mapbox://styles/mapbox/streets-v12',
            center: [finalLng, finalLat],
            zoom: isValidLat && isValidLng ? 15 : 11
        });

        // Initialize Marker (not draggable in view mode)
        markerRef.current = new mapboxgl.Marker({
            draggable: false,
            color: "#ef4444"
        })
            .setLngLat([finalLng, finalLat])
            .addTo(mapRef.current);
    };
    const destroyMap = () => {
        if (mapRef.current) {
            mapRef.current.remove();
            mapRef.current = null;
            markerRef.current = null;
        }
    };

    const recurringStatusOptions = [
        {id: 1, name: 'Recurring'},
        {id: 0, name: 'Non-recurring'},
    ]

    const statuses = [
        {id: 3, name: 'Completed'},
        {id: 2, name: 'Cancelled'},
        {id: 1, name: 'Reserved'},
    ];


    // pagination
    const {page, limitData, handlePageChange} = usePagination();
    // endpoint
    const mainTitle = "Parking Reservation"
    const tableDataEndpointUrl = `/vehicle-parking-reservations?page=${page} `
    const submitFormEndpointUrl = updatedId ? `/vehicle-parking-reservations/${updatedId}` : "/vehicle-parking-reservations";

    console.log('deleteId', deleteId.current)

    const accept = () => {
        const deleteParams = {
            id: deleteId.current,
            startEndpoint: "/vehicle-parking-reservations/",
            // finalEndpoint: finalEndpoint,
            name: "Reservation",
            setUpdate: setRefresh,
            token: accessToken,
            toast: toastRef,
        }

        handleDelete(deleteParams).then()
    }

    // fetch data
    const {
        data: tableDataList,
        totalData, loading
    } = useFetch(tableDataEndpointUrl, [refresh])

    // fetch dorpdown data
    // vehicle fetch
    const {data: vehicleRawData} = useFetch(
        `/vehicle?page=1&per_page=10${vehicleNameFilter ? `&model=${vehicleNameFilter}` : ''}`,
        [vehicleNameFilter]
    );

    useEffect(() => {
        if (vehicleRawData) {
            const modifiedData = vehicleRawData?.map((item: any) => ({
                id: item?.id,
                model: item?.model,
                // serial_number: item?.serial_number,
            }));
            setVehicleOptions(mergeWithSelected(modifiedData, formData?.vehicle_id));
        }
    }, [vehicleRawData, formData?.vehicle_id]);

    // employee fetch
    const {data: userRawData} = useFetch(
        `/employees?page=1&per_page=10${userFilter ? `&name=${userFilter}` : ''}`,
        [userFilter]
    );

    useEffect(() => {
        if (userRawData) {
            const modifiedData = userRawData?.map((item: any) => ({
                id: item?.id,
                name: item?.name,
                email: item?.email,
            }));
            setUserOptions(mergeWithSelected(modifiedData, formData?.user_id));
        }
    }, [userRawData, formData?.user_id]);


    // parking campus
    const {data: parkingCampusRawData} = useFetch(
        `/vehicle-parking-campuses?page=1&per_page=10${parkingCampusNameFilter ? `&name=${parkingCampusNameFilter}` : ''}`,
        [parkingCampusNameFilter]
    );
    useEffect(() => {
        if (parkingCampusRawData) {
            const modifiedData = parkingCampusRawData?.map((item: any) => ({
                id: item?.id,
                name: item?.name
            }));
            setParkingCampusOptions(mergeWithSelected(modifiedData, formData?.vehicle_parking_campus_id));
        }
    }, [parkingCampusRawData, formData?.vehicle_parking_campus_id]);

    // parking floor
    const {
        data: parkingFloorRawData
    } = useFetch(`/vehicle-parking-campuses/${formData.vehicle_parking_campus_id?.id}/floors?page=1&per_page=10${parkingFloorNameFilter ? `&floor_name=${parkingFloorNameFilter}` : ''}`, [parkingFloorNameFilter, formData?.vehicle_parking_campus_id], true, formData?.vehicle_parking_campus_id !== null);

    useEffect(() => {
        if (parkingFloorRawData) {
            const modifiedData = parkingFloorRawData?.map((item: any) => ({
                id: item?.id,
                floor_name: item?.floor_name,
                floor_level: item?.floor_level
            }));
            setParkingFloorOptions(mergeWithSelected(modifiedData, formData?.vehicle_parking_floor_id));
        }
    }, [parkingFloorRawData, formData?.vehicle_parking_floor_id]);


    // parking slot
    const {
        data: parkingSlotRawData
    } = useFetch(`/vehicle-parking-slots?page=1&per_page=10&vehicle_parking_floor_id=${formData?.vehicle_parking_floor_id?.id}${parkingSlotNameFilter ? `&slot_code=${parkingSlotNameFilter}` : ''}`, [parkingSlotNameFilter, formData?.vehicle_parking_floor_id], true, formData?.vehicle_parking_floor_id !== null);

    useEffect(() => {
        if (parkingSlotRawData) {
            const modifiedData = parkingSlotRawData?.map((item: any) => ({
                id: item?.id,
                slot_code: item?.slot_code,
            }));
            setParkingSlotOptions(mergeWithSelected(modifiedData, formData?.parking_slot_id));
        }
    }, [parkingSlotRawData,formData?.parking_slot_id]);

    function formatDateTime(date: Date): string {
        const pad = (n: number) => n.toString().padStart(2, '0');
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
            `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    }

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const validationRules = [
            {field: 'vehicle_parking_campus_id', label: 'Parking campus'},
            {field: 'vehicle_parking_floor_id', label: 'Parking floor'},
            {field: 'vehicle_parking_slot_id', label: 'Parking slot'},
            {field: 'reservation_start_date', label: 'Reservation start date'},
            {field: 'reservation_end_date', label: 'Reservation end date'},
            {field: 'vehicle_id', label: 'Vehicle'},
            {field: 'user_id', label: 'User'},
        ];

        if (!validateFormFields(formData, validationRules, toastRef)) return;

        const payload = {
            vehicle_id: formData.vehicle_id?.id,
            user_id: formData.user_id?.id,
            vehicle_parking_slot_id: formData.vehicle_parking_slot_id?.id,
            reservation_start_date: formatDateTime(formData.reservation_start_date),
            reservation_end_date: formatDateTime(formData.reservation_end_date),

        };

        try {
            setIsSubmitting(true);
            const response = await fetch(`${webInfo?.baseUrl}${submitFormEndpointUrl}`, postData("PUT", accessToken, payload));

            if (response.ok) {
                callToast(toastRef, true, `Vehicle ${updatedId ? 'updated' : 'created'} successfully`);
                setFormData(initialState)
                setModal(false)
                setUpdatedId(null)
                setParkingSlotNameFilter('')
                setParkingCampusNameFilter('')
                setParkingFloorNameFilter('')
                setVehicleNameFilter('')
                setUserFilter('')
                setRefresh(!refresh);
                return;
            } else {
                const resData = await response.json();
                callToast(toastRef, false, resData.error);
            }

        } catch (err) {
            console.error('Failed to update', err);
        } finally {
            setIsSubmitting(false);
        }

    }


    const statusChangeSubmit = async (payload:any, submittingState: (val: boolean) => void, startingUrl: string, endingUrl: string, id: number, title: string): Promise<void> =>{
        try {
            submittingState(true);
            const response = await fetch(
                `${webInfo.baseUrl}/${startingUrl}/${id}/${endingUrl}`,
                postData("PUT", accessToken, payload)
            );
            if (response.ok) {
                callToast(toastRef, true, `${title} updated`);
                setRecurringStatusEditMode(false)
                setStatusEditMode(false)
                setRefresh(prev => !prev);

            } else {
                const resData = await response.json();
                callToast(toastRef, false, resData.error);
            }
        } catch (err) {
            callToast(toastRef, false, `Failed to update ${title}`);
        } finally {
            submittingState(false);
        }
    }

    const statusDropdownValueTemplate = (option: any, submittingState: boolean) => {
        if (submittingState) {
            return (
                <div className="flex align-items-center justify-content-between w-full">
                    <span>{option ? option.name : ''}</span>
                    <ProgressSpinner style={{ width: '1.5rem', height: '1.5rem' }} strokeWidth="4" />
                </div>
            );
        }
        return option ? option.name : '';
    };


    // row edit template
    const actionTemplate = (rowData: any) => {

        return (
            <div className={'flex align-items-center justify-content-end gap-2'}>
                <Button icon={'pi pi-pencil'} className={'border-rounded w-2rem h-2rem'} onClick={() => {
                    console.log("row data",rowData)
                    setModal(true)
                    setUpdatedId(rowData?.id)
                    setFormData({
                        vehicle_id: rowData?.vehicle,
                        user_id: rowData?.user,
                        reservation_start_date: new Date(rowData?.reservation_start_date),
                        reservation_end_date: new Date(rowData?.reservation_end_date),
                        vehicle_parking_slot_id: rowData?.parking_slot ? { id: rowData?.parking_slot?.id, slot_code: rowData?.parking_slot?.slot_code} : null   ,
                        vehicle_parking_campus_id: rowData?.parking_slot?.parking_floor?.campus ? { id: rowData?.parking_slot?.parking_floor?.campus?.id, name: rowData?.parking_slot?.parking_floor?.campus?.name} : null,
                        vehicle_parking_floor_id: rowData?.parking_slot?.parking_floor? { id: rowData?.parking_slot?.parking_floor?.id, floor_level: rowData?.parking_slot?.parking_floor?.floor_level, floor_name: rowData?.parking_slot?.parking_floor?.floor_name}: null,
                    })
                }} outlined/>

                <Button
                    icon={'pi pi-trash'}
                    // tooltip={'Delete reservation'}
                    className={'border-rounded w-2rem h-2rem'}
                    outlined
                    onClick={(event: any) => {
                        // setDeletedFloorId(rowData?.id);
                        deleteId.current = rowData?.id;
                        confirmPopup({
                            target: event.currentTarget,
                            message: `Do you want to delete this reservation?`,
                            // message: `Do you want to delete this ${mainTitle.toLowerCase()}`,
                            icon: 'pi pi-info-circle',
                            acceptClassName: 'p-button-danger',
                            accept,
                            onHide() {
                                deleteId.current = 0;
                            }
                        })
                    }}
                />
            </div>
        )
    }

    const parkingSlotBodyTemplate = (rowData: any) => {
        const hasLatLng = rowData?.parking_slot?.parking_floor?.campus?.latitude && rowData?.parking_slot?.parking_floor?.campus?.longitude;
        return (
            <div className="flex flex-column gap-1">
                <span className="font-semibold text-900 text-sm">
                    {rowData?.parking_slot?.slot_code || '-'}
                </span>
                {/*<span className="text-700 text-xs">*/}
                {/*    {rowData?.parking_slot?.parking_floor?.floor_name || '-'}*/}
                {/*</span>*/}
                <span className="text-700 text-xs">
                    Level {rowData?.parking_slot?.parking_floor?.floor_level|| '-'}
                </span>
                <span className="text-700 text-xs flex align-items-center">
                    {hasLatLng && (
                        <i
                            className="pi pi-map-marker mr-2 cursor-pointer"
                            onClick={() => {

                                setMapModal(true);
                                setLocationData({
                                    latitude: rowData?.parking_slot?.parking_floor?.campus?.latitude,
                                    longitude: rowData?.parking_slot?.parking_floor?.campus?.longitude,
                                    name: rowData?.parking_slot?.parking_floor?.campus?.name,
                                    address: rowData?.parking_slot?.parking_floor?.campus?.address,
                                })

                            }}
                            style={{color: '#ef4444'}}/>
                    )}
                    {rowData?.parking_slot?.parking_floor?.campus?.name || '-'}

            </span>
            </div>
        );
    };

    const userBodyTemplate = (rowData: any) => {
        return (
            <div className="flex flex-column gap-1">
            <span className="font-semibold text-900 text-sm">
                {rowData?.user?.name || '-'}
            </span>
                <span className="text-700 text-xs">
                {rowData?.user?.email || '-'}
            </span>
            </div>
        )
    }

    const reservationTimeBodyTemplate = (rowData: any) => {
        return (
            <div className="flex flex-row gap-3 align-items-center">
                <div className="flex flex-column align-items-start">
                    <span className="text-xs text-700">From</span>
                    <span className="font-semibold text-900 text-sm">
                    {formattedDateTime(rowData?.reservation_start_date, true)}
                </span>
                </div>
                <i className="pi pi-arrow-right text-400 text-lg mx-2" />
                <div className="flex flex-column align-items-start">
                    <span className="text-xs text-700">To</span>
                    <span className="font-semibold text-900 text-sm">
                    {formattedDateTime(rowData?.reservation_end_date, true)}
                </span>
                </div>
            </div>
        );
    };

    function message(msg: string, status: string) {
        return <span className={`custom-badge ${status}`}>{msg}</span>;
    }

    const recurringStatusBodyTemplate = (rowData: any) => {
        // console.log("rowData",rowData)
        if(!recurringStatusEditMode){
            return<span onClick={() => setRecurringStatusEditMode(true)}
                className={'w-full cursor-pointer'}>{rowData.recurring_status === 1 ? message("Recurring", "approved") : message("Non Recurring", "cancelled")}</span>;
        }
        return (
            <Dropdown
                options={recurringStatusOptions}
                optionLabel="name"
                value={recurringStatusOptions.find(opt => opt.id === rowData?.recurring_status)}
                onChange={(e) => {
                    const payload = { recurring_status: e.value.id };
                    statusChangeSubmit(payload, setRecurringStatusIsSubmitting, `vehicle-parking-reservations`, `recurring-status`, rowData.id, "Recurring status");
                }}
                className="w-full"
                disabled={recurringStatusIsSubmitting}
                valueTemplate={(option) =>statusDropdownValueTemplate(option, recurringStatusIsSubmitting)}
                // autoFocus
                // onBlur={() => setRecurringStatusEditMode(false)}
            />
        );
    };

    const statusBodyTemplate = (rowData: any) => {

        if (!statusEditMode) {
            let statusLabel = "-";
            let statusClass = "";
            if (rowData.status === 3) {
                statusLabel = "Completed";
                statusClass = "approved";
            } else if (rowData.status === 2) {
                statusLabel = "Cancelled";
                statusClass = "cancelled";
            } else if (rowData.status === 1) {
                statusLabel = "Reserved";
                statusClass = "new";
            }
            return (
                <span
                    onClick={() => setStatusEditMode(true)}
                    className="w-full cursor-pointer"
                >
            {message(statusLabel, statusClass)}
        </span>
            );
        }

        return (
            <Dropdown
                options={statuses}
                optionLabel="name"
                value={statuses.find(opt => opt.id === rowData?.status)}
                onChange={(e) => {
                    const payload = { status: e.value.id };
                    statusChangeSubmit(payload, setStatusIsSubmitting, `vehicle-parking-reservations`, `status`, rowData.id, "Status");
                }}
                className="w-full"
                disabled={statusIsSubmitting}
                valueTemplate={(option) =>statusDropdownValueTemplate(option, statusIsSubmitting)}
            />
        );
    };



    const ownerTypeBodyTemplate = (rowData: any) => {
        return <span
            className={'w-full'}>{rowData.is_company_owned === 1 ? message("Company Owned", "secondary") : message("Personal Owned", "new")}</span>;
    }


    const formVehicleDropdownItemTemplate = (option: any) => {
        return (
            <div className="flex flex-column gap-1">
                <span className="font-semibold text-900 text-sm">{option?.model}</span>
                <span className="text-xs text-700">{option?.serial_number}</span>
            </div>
        );
    }
    const formUserDropdownItemTemplate = (option: any) => {
        return (
            <div className="flex flex-column gap-1">
                <span className="font-semibold text-900 text-sm">{option?.name}</span>
                <span className="text-xs text-700">{option?.email}</span>
            </div>
        );
    }

    const floorDropdownItemTemplate =(option: any) => {
        return (
            <div className="flex flex-column gap-1">
                <span className="font-semibold text-900 text-sm">{option?.floor_name}</span>
                <span className="text-xs text-700">Level {option?.floor_level}</span>
            </div>
        )
    }

    return (
        <div className={"card"}>
            <Toast ref={toastRef}/>
            <ConfirmPopup/>
            <PageHeading title={mainTitle}
                         isCreate={true}
                         createFunction={() => setModal(true)}
                         back={true}
            />

            <DataTable
                value={tableDataList}
                dataKey="id"
                tableStyle={{minWidth: '50rem'}}
                paginator={tableDataList?.length > 0}
                lazy
                first={(page - 1) * limitData}
                rows={limitData}
                totalRecords={totalData}
                loading={loading}
                onPage={handlePageChange}
            >
                <Column
                    field="user"
                    header="User"
                    style={{width: '15%'}}
                    body={userBodyTemplate}
                    headerClassName={"white-space-nowrap"}

                />
                <Column
                    field="vehicle"
                    header="Vehicle"
                    style={{width: '15%'}}
                    body={(rowData: any) => rowData?.vehicle?.model}
                    headerClassName={"white-space-nowrap"}
                />
                <Column
                    field="parking_slot"
                    header="Parking Slot"
                    style={{width: '15%'}}
                    body={parkingSlotBodyTemplate}
                    headerClassName={"white-space-nowrap"}
                />
                <Column
                    field="reservation_start_date"
                    header="Reservation time"
                    body={reservationTimeBodyTemplate}
                    style={{width: '20%'}}
                    headerClassName={"white-space-nowrap"}
                />


                <Column
                    field={"is_company_owned"}
                    header="Owner Type"
                    style={{width: '10%'}}
                    body={ownerTypeBodyTemplate}
                    headerClassName={"white-space-nowrap "}
                />

                <Column
                    field={"recurring_status"}
                    header="Recurring Status"
                    style={{width: '10%'}}
                    body={recurringStatusBodyTemplate}
                    headerClassName={"white-space-nowrap"}
                />

                <Column
                    field={"status"}
                    header="Status"
                    style={{width: '10%'}}
                    body={ statusBodyTemplate}
                    headerClassName={"white-space-nowrap"}
                />



                <Column header={"Action"} rowEditor={true}
                        bodyStyle={{textAlign: 'center'}}
                        body={actionTemplate}
                        headerClassName={"flex justify-content-end"}
                />

            </DataTable>

            <Dialog visible={modal}
                    style={{width: "50rem"}}
                    headerClassName="text-800 font-semibold text-xl"
                    header={updatedId ? `Edit ${mainTitle}` : `New ${mainTitle}`}
                    breakpoints={{"960px": "75vw", "640px": "90vw"}}
                    onHide={() => {
                        setUpdatedId(null)
                        setModal(false)
                        setParkingSlotNameFilter('')
                        setParkingCampusNameFilter('')
                        setParkingFloorNameFilter('')
                        setVehicleNameFilter('')
                        setUserFilter('')
                        setFormData(initialState)

                    }}
            >
                <div>
                    <form className={''}
                          onSubmit={handleSubmit}
                    >
                        <div className="grid ">
                            <div className="col-12  md:col-5">
                                <Label label={"Vehicle"} required={!updatedId}/>
                                <Dropdown
                                    options={vehicleOptions? vehicleOptions : []}
                                    optionLabel="model"
                                    id="vehicle_id"
                                    name={`vehicle_id`}
                                    className={`w-full`}
                                    value={formData?.vehicle_id}
                                    onChange={(e) => handleChangeData('vehicle_id', e.value, formData, setFormData)}
                                    placeholder="Select vehicle"
                                    filter
                                    onFilter={(e) => {
                                        if (timeoutRef?.current) {
                                            clearTimeout(timeoutRef.current);
                                        }
                                        timeoutRef.current = setTimeout(() => {
                                            setVehicleNameFilter(e.filter)
                                        }, 500);

                                        if (vehicleRawData) {
                                            const modifiedData = vehicleRawData.map((item: any) => ({
                                                id: item?.id,
                                                model: item?.model,
                                                serial_number: item?.serial_number,
                                            }));
                                            setVehicleOptions(modifiedData);
                                        }
                                    }}
                                    valueTemplate={(option)=>option? option?.model + '-' + option?.serial_number : 'Select vehicle'}
                                    itemTemplate={formVehicleDropdownItemTemplate}
                                    showClear
                                    showFilterClear
                                />
                            </div>
                            <div className="col-12  md:col-5">
                                <Label label={"User"} required={!updatedId}/>
                                <Dropdown
                                    options={userOptions? userOptions : []}
                                    optionLabel="name"
                                    id="user_id"
                                    name={`user_id`}
                                    className={`w-full`}
                                    value={formData?.user_id}
                                    onChange={(e) => handleChangeData('user_id', e.value, formData, setFormData)}
                                    placeholder="Select user"
                                    filter
                                    onFilter={(e) => {
                                        if (timeoutRef?.current) {
                                            clearTimeout(timeoutRef.current);
                                        }
                                        timeoutRef.current = setTimeout(() => {
                                            setUserFilter(e.filter)
                                        }, 500);

                                        if (userRawData) {
                                            const modifiedData = userRawData.map((item: any) => ({
                                                id: item?.id,
                                                name: item?.name,
                                                email: item?.email,
                                            }));
                                            setUserOptions(modifiedData);
                                        }
                                    }}
                                    // valueTemplate={(option)=>option? option?.name + '-' + option?.email : 'Select user'}
                                    itemTemplate={formUserDropdownItemTemplate}
                                    showClear
                                    showFilterClear
                                />
                            </div>
                        </div>
                        <div className={"grid mt-2"}>
                            <div className="col-12  md:col-4">
                                <Label label={"Parking Campus"} required={!updatedId}/>
                                <Dropdown
                                    options={parkingCampusOptions? parkingCampusOptions : []}
                                    optionLabel="name"
                                    id="vehicle_parking_campus_id"
                                    name={`vehicle_parking_campus_id`}
                                    className={`w-full`}
                                    value={formData?.vehicle_parking_campus_id}

                                    onChange={(e) => handleChangeData('vehicle_parking_campus_id', e.value, formData, setFormData)}
                                    placeholder="Select campus"
                                    filter
                                    onFilter={(e) => {
                                        if (timeoutRef?.current) {
                                            clearTimeout(timeoutRef.current);
                                        }
                                        timeoutRef.current = setTimeout(() => {
                                            setParkingCampusNameFilter(e.filter)
                                        }, 500);

                                        if (parkingCampusRawData) {
                                            const modifiedData = parkingCampusRawData.map((item: any) => ({
                                                id: item?.id,
                                                name: item?.name
                                            }));
                                            setParkingCampusOptions(modifiedData);
                                        }
                                    }}
                                    showClear
                                    showFilterClear
                                />
                            </div>
                            <div className="col-12  md:col-4">
                                <Label label={"Parking floor"} required={!updatedId}/>
                                <Dropdown
                                    options={parkingFloorOptions? parkingFloorOptions : []}
                                    id="vehicle_parking_floor_id"
                                    name={`vehicle_parking_floor_id`}
                                    optionLabel="floor_name"
                                    className={`w-full`}
                                    value={formData?.vehicle_parking_floor_id}
                                    onChange={(e) => handleChangeData('vehicle_parking_floor_id', e.value, formData, setFormData)}
                                    placeholder="Select floor"
                                    disabled={formData?.vehicle_parking_campus_id === null}
                                    itemTemplate={floorDropdownItemTemplate}
                                    filter
                                    onFilter={(e) => {
                                        if (timeoutRef?.current) {
                                            clearTimeout(timeoutRef.current);
                                        }
                                        timeoutRef.current = setTimeout(() => {
                                            setParkingFloorNameFilter(e.filter)
                                        }, 500);

                                        if (parkingFloorRawData) {
                                            const modifiedData = parkingFloorRawData.map((item: any) => ({
                                                id: item?.id,
                                                floor_name: item?.floor_name,
                                                floor_level: item?.floor_level,
                                            }));
                                            setParkingFloorOptions(modifiedData);
                                        }
                                    }}
                                    showClear
                                    showFilterClear
                                />
                            </div>
                            <div className="col-12  md:col-4">
                                <Label label={"Parking slot"} required={!updatedId}/>
                                <Dropdown
                                    options={parkingSlotOptions ? parkingSlotOptions : []}
                                    optionLabel="slot_code"
                                    id="vehicle_parking_slot_id"
                                    name={`vehicle_parking_slot_id`}
                                    className={`w-full`}
                                    value={formData?.vehicle_parking_slot_id}
                                    onChange={(e) => handleChangeData('vehicle_parking_slot_id', e.value, formData, setFormData)}
                                    placeholder="Select slot"
                                    filter
                                    disabled={formData?.vehicle_parking_floor_id === null}
                                    onFilter={(e) => {
                                        if (timeoutRef?.current) {
                                            clearTimeout(timeoutRef.current);
                                        }
                                        timeoutRef.current = setTimeout(() => {
                                            setParkingSlotNameFilter(e.filter)
                                        }, 500);

                                        if (parkingSlotRawData) {
                                            const modifiedData = parkingSlotRawData.map((item: any) => ({
                                                id: item?.id,
                                                slot_code: item?.slot_code,
                                            }));
                                            setParkingCampusOptions(modifiedData);
                                        }
                                    }}
                                    showClear
                                    showFilterClear
                                />
                            </div>
                        </div>

                        <div className="grid mt-2">
                            <div className="col-12 md:col-5">
                                <Label label={"Reservation Start Time"} required={!updatedId}/>
                                <Calendar
                                    id="reservation_start_date"
                                    value={formData.reservation_start_date}
                                    name="reservation_start_date"
                                    onChange={(e) => handleChangeData('reservation_start_date', e.value, formData, setFormData)}
                                    placeholder="Select reservation start time"
                                    className="w-full mb-2"
                                    showTime
                                    dateFormat="yy-mm-dd"
                                />
                            </div>
                            <div className="col-12 md:col-5">
                                <Label label={"Reservation End Time"} required={!updatedId}/>
                                <Calendar
                                    id="reservation_end_date"
                                    value={formData.reservation_end_date}
                                    name="reservation_end_date"
                                    onChange={(e) => handleChangeData('reservation_end_date', e.value, formData, setFormData)}

                                    placeholder="Select reservation end time"
                                    className="w-full"
                                    showTime
                                    dateFormat="yy-mm-dd"
                                />
                            </div>

                        </div>
                        <div className="flex gap-2 mt-2">
                            <Button
                                type="submit"
                                label={updatedId ? 'Update' : "Create"}
                                className="p-button-primary"
                                size={'small'}
                                loading={isSubmitting}
                            />
                        </div>
                    </form>
                </div>
            </Dialog>


            {/* VIEW MAP MODAL */}
            <Dialog visible={mapModal} style={{width: "50rem"}} header={"Location Details"} onHide={() => {
                setMapModal(false);
                setLocationData({
                    latitude: '90.4125', longitude: '23.8103', name: '', address: ''
                });
                destroyMap();
            }} onShow={initMap}>
                <div className="grid">
                    <div className="col-12">
                        <div className="surface-100 p-3 border-round mb-3">
                            <div className="font-bold text-lg mb-1">{locationData.name}</div>
                            <div className="text-600 mb-2"><i className="pi pi-map-marker mr-1"/>{locationData.address}
                            </div>
                        </div>
                        <div ref={showMapContainerRef} style={{
                            height: '400px',
                            width: '100%',
                            borderRadius: '8px',
                            border: '1px solid #dee2e6'
                        }}/>
                    </div>
                </div>
            </Dialog>

        </div>
    );
};

export default ParkingReservation;

